import { useUserHasPermissions } from '../../common/hooks'

const useCanUserUnassignTask = unassignPermission =>
  useUserHasPermissions([unassignPermission])

export default useCanUserUnassignTask
